var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTelegramWhite = function SvgTelegramWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 50 51"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 49.878,
    height: 49.878,
    x: 0.092,
    y: 0.355,
    fill: "#fff",
    rx: 24.939
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#717172",
    d: "M35.006 16.07 31.26 35.635s-.524 1.356-1.965.706l-8.647-6.866-.04-.02a5960 5960 0 0 0 10.621-9.9c.613-.593.232-.945-.48-.498l-13.377 8.798-5.162-1.799s-.812-.299-.89-.95c-.08-.65.917-1.003.917-1.003l21.041-8.548s1.73-.787 1.73.515"
  })));
};
export default SvgTelegramWhite;